/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useContext, useEffect } from 'react';
import useSWR from 'swr';
import {
  Table,
  TableBody,
  TableHead,
  TableRow,
} from '@mui/material';
import { Modal, Snackbar } from 'Components';
import { AppContext } from 'Context';
import { dataFetcher, endpoints } from 'Api';
import CheckButton from 'Assets/check-button.png';
import cn from 'classnames';
import { TableCell, TableHeaderCell, Checkbox } from '../videos/components/CustomDesigns';
import styles from './index.module.css';

const defaultSnackbar = { isVisible: false, type: undefined, message: undefined };
const AddContentModal = ({ isVisible, onHide: onClose, title, selectedBannerType, selectedContent, selectContent, updateBannerType }) => {
  const { langText } = useContext(AppContext);
  const commonText = langText?.common;
  const [snackbar, setSnackbar] = useState(defaultSnackbar);
  const [content, setContent] = useState(undefined);
  const onHide = () => {
    setContent(undefined);
    setSnackbar(defaultSnackbar);
    // selectContent([]);
    onClose();
  };

  const { isValidating: gettingContentDetails, mutate: getContentDetails } = useSWR([endpoints.getMyAllPhotosNVideos], {
    fetcher: (url) => dataFetcher(url),
    onSuccess: ({ success, data }) => {
      if (success) {
        setContent(data[selectedBannerType === '3' ? 'photo' : selectedBannerType === '4' ? 'video' : 'album']);
      } else {
        setSnackbar({ isVisible: true, type: 'error', message: 'Oops! Something went wrong' });
      }
    },
    onError: () => {
      setSnackbar({ isVisible: true, type: 'error', message: 'Oops! Something went wrong' });
    },
  });

  useEffect(() => {
    if (isVisible) {
      getContentDetails();
    }
  }, [isVisible]);

  const changeDateFormat = (date) => {
    if (date) {
      const [year, month, day] = date.split('-');
      return (`${month}/${day}/${year}`);
    }
  };

  const selectContentHandler = (contentId, name) => {
    if (selectedContent.some((content) => content.id === contentId)) {
      // remove item
      const arr = selectedContent.filter((item) => item.id !== contentId);
      selectContent(arr);
    } else if (selectedContent?.length < 5) {
      selectContent([...selectedContent, { id: contentId, name }]);
    }
  };

  const saveContent = () => {
    updateBannerType();
    onClose();
  };

  return (
    <>
      <Modal
        isVisible={isVisible}
        cancelButton={commonText?.cancel || 'Cancel'}
        cancelButtonClassName={styles.actionButton}
        continueButton={commonText?.save || 'Save'}
        continueButtonClassName={styles.actionButton}
        // continueButtonProps={{
        //   isDisabled: updatingPassword
        // }}
        onCancelButtonClick={onHide}
        onContinueButtonClick={saveContent}
        onHide={onHide}
        title={title}
        addContentModal
        selectedCount={selectedContent?.length}
      >
        <br />
        <br />
        {
          selectedBannerType === '3' ? (
            <>
              <div className={styles.photoHeading}>Images</div>
              <div className={styles.alignRow}>
                {content?.map(({ photo_file, id }, idx, arr) => (
                  <div
                    onClick={() => { selectContentHandler(id, id); }}
                    className={styles.imageColumn}
                    // className={cn({ [styles.imageColumn]: true, [styles.imageSelected]: selectedContent.some((content) => content.id === id) })}
                  >
                    {
                      selectedContent.some((content) => content.id === id) ? (
                        <img className={styles.tickBotton} src={CheckButton} alt="Snow" />
                      ) : null
                    }
                    <img
                      src={photo_file}
                      // className={styles.selectedImage}
                      alt="Snow"
                      style={{ width: '100%', height: '150px' }}
                      className={cn({ [styles.selectedImage]: true, [styles.imageSelected]: selectedContent.some((content) => content.id === id) })}
                    />
                  </div>
                ))}
              </div>
            </>
          ) : (
            <Table id="menu-bar-table">
              <TableHead className={styles.tableHeader}>
                <TableRow className={styles.preferenceContainer}>
                  <TableHeaderCell
                    align="center"
                    className={cn({ [styles.headerCell]: true, [styles.checkboxCell]: true })}
                  />
                  <TableHeaderCell
                    align="left"
                    className={cn({ [styles.headerCell]: true, [styles.photoHeading]: true })}
                  >
                    {selectedBannerType === '4' ? 'Videos' : 'Albums'}
                  </TableHeaderCell>
                  <TableHeaderCell align="center" className={styles.headerCell}>
                    {selectedBannerType === '4' ? 'Video title' : 'Album title'}
                  </TableHeaderCell>
                  <TableHeaderCell align="center" className={styles.headerCell}>
                    {selectedBannerType === '4' ? 'Category name' : null}
                  </TableHeaderCell>
                  <TableHeaderCell align="center" className={styles.headerCell}>
                    {selectedBannerType === '4' ? 'Subcategory name' : null}
                  </TableHeaderCell>
                  <TableHeaderCell align="center" className={styles.headerCell}>
                    Published date
                  </TableHeaderCell>
                </TableRow>
              </TableHead>
              <TableBody className={styles.tableBody}>
                {
                  content?.map(({
                    id, thumbnail, file, publish_date,
                    status, subcategory_id, title, type, views, visibility, subCategory, content_status, category, album_size, photo_file
                  }, idx, arr) => ((
                    <TableRow>
                      <TableCell className={styles.bodyCell}>
                        <Checkbox
                          status={selectedContent.some((content) => content.id === id)}
                          onClick={() => { selectContentHandler(id, selectedBannerType === '3' ? id : title); }}
                        />
                      </TableCell>
                      <TableCell
                        align="left"
                        className={cn({ [styles.bodyCell]: true, [styles.videoPreviewCell]: true })}
                      >
                        <img
                          className={styles.previewImage}
                          src={thumbnail || photo_file}
                          alt={id}
                        />
                      </TableCell>
                      <TableCell align="center" className={styles.bodyCell}>
                        {title}
                      </TableCell>
                      <TableCell align="center" className={styles.bodyCell}>
                        {category}
                      </TableCell>
                      <TableCell align="center" className={styles.bodyCell}>{subCategory}</TableCell>
                      <TableCell align="center" className={styles.bodyCell}>
                        {changeDateFormat(publish_date?.split(' ')[0])}
                      </TableCell>
                    </TableRow>
                  )))
                }
              </TableBody>
            </Table>
          )
        }
      </Modal>

      <Snackbar
        isVisible={snackbar?.isVisible}
        message={snackbar?.message || ''}
        onClose={() => { setSnackbar(defaultSnackbar); }}
        type={snackbar?.type}
      />
    </>
  );
};
export default AddContentModal;
